<template>
	<div class="inner-wrapper" v-if="user.access_rights.is_owner || user.is_can_dismiss || user.is_can_dismiss && user.is_can_contract">
		<div class="h-nav-wrap df">
            <div class="h-nav">
                <div class="h-nav-item">
                    <router-link :to="'/staff/'+sid" class="h-nav-item-link h-link" :exact="true" :class="{active:($route.params.sid == 'refuse' || $route.params.sid == 'dismiss')}">
                        <span>Пользователи</span>
                    </router-link>
                </div>
            </div>
            <div class="h-nav">
                <div class="h-nav-item">
                    <router-link :to="'/staff/contract/'+sid" class="h-nav-item-link h-link">
                        <span>ДОГОВОРЫ</span>
                    </router-link>
                </div>
            </div>
		</div>
	</div>
</template>
<script>
    import { mapState } from 'vuex'
    export default {
        name: "TopSectionsStaff",
        components: {

        },
        props: {

        },
		data(){
			return {

			}
		},
        mounted() {

        },
        methods: {

        },
        computed: {
            ...mapState({
                user: state => state.users.user,
            }),
            sid(){
                return this.$route.params.sid !== 'deleted' && this.$route.params.sid !== 'dismiss' && this.$route.params.sid !== 'refuse' && this.$route.params.sid ? this.$route.params.sid : ''
            }
        }
    }
</script>
